import { useContext } from 'react';
import { PusherContext } from './provider';

function usePusher() {
  const { client } = useContext(PusherContext);
  return client.current;
}

export default usePusher;
